import { render, staticRenderFns } from "./SendListView.vue?vue&type=template&id=cf527f80&scoped=true"
import script from "./SendListView.vue?vue&type=script&lang=js"
export * from "./SendListView.vue?vue&type=script&lang=js"
import style0 from "./SendListView.vue?vue&type=style&index=0&id=cf527f80&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf527f80",
  null
  
)

export default component.exports